import { ref } from 'vue'

export enum TOOLTIP_COMPONENTS {
  POST_VOTE = 'PostVoteTooltip',
  POST_VOTE_LOGIN = 'PostVoteLoginTooltip',
  POST_ERROR = 'PostError',
  POST_SUPER_LIKE = 'PostSuperLikeTooltip',
  POST_BANNED = 'PostBannedTooltip',
  POST_SUBSCRIBE = 'PostSubscribeTooltip',
  POST_SUBSCRIBE_LOGIN = 'PostSubscribeLoginTooltip',
  POST_REPORT_CONFIRMATION = 'PostReportConfirmationTooltip',
  POST_SUPER_LIKE_UPGRADE = 'PostSuperLikeUpgradeTooltip',
  POST_EDIT = 'PostEditTooltip',
  POST_SUPER_LIKE_BUY_SUBSCRIPTION = 'PostSuperLikeBuySubscriptionTooltip',
  POST_SUPER_LIKE_LOGIN = 'PostSuperLikeLoginTooltip',
  POST_SUPER_LIKE_QUOTA = 'PostSuperLikeQuotaTooltip',
  POST_COPY = 'PostCopyUrl',
}

export function usePostTooltip() {
  const currentComponent = ref()
  const alreadyPerformed = ref(false)
  const changed = ref(false)

  return {
    currentComponent,
    alreadyPerformed,
    changed,
  }
}
